import React from "react";
import PropTypes from "prop-types";
import RouteWithSubRoutes from "./RouteWithSubRoutes";
import { Switch, Route, Redirect } from "react-router-dom";
import { mapStateToPropsLogin } from "../../modules/login";
import { connect } from "react-redux";

export class RoutesBase extends React.Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    route: PropTypes.object,
    default: PropTypes.string,
  };

  render() {
    const props = this.props;
    const routesConfig = props.routes;

    const routes = routesConfig.map((route, i) => (
      <RouteWithSubRoutes
        isLoggedIn={props.isLogged}
        key={i}
        {...route}
        onRouteChange={props.onRouteChange}
        onProtectedRouteChange={props.onProtectedRouteChange}
        exact
      />
    ));

    const defaultRoute =
      props.route && props.route.default ? props.route.default : props.default;
    const parentRoute = props.route ? props.route.path : "/";
    const redirect = defaultRoute ? (
      <Route
        exact
        path={parentRoute}
        render={() => <Redirect to={defaultRoute} />}
      />
    ) : null;
    return (
      <Switch>
        {redirect}
        {routes}
      </Switch>
    );
  }
}

export default connect(mapStateToPropsLogin, {})(RoutesBase);
